var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_21577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15536 10.6511V5.16595L1.49179 3.6097L3.05176e-05 2.74609V9.68308C3.05176e-05 10.2187 0.424397 10.6511 0.946652 10.6511H3.15536Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7285 10.651H12.9372C13.4611 10.651 13.8838 10.217 13.8838 9.68303V2.74609L12.1942 3.73525L10.7285 5.1659V10.651Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.15605 5.16514L2.92969 3.02195L3.15605 0.970703L6.94243 3.87458L10.7288 0.970703L10.982 2.9112L10.7288 5.16514L6.94243 8.06901L3.15605 5.16514Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7266 0.970677V5.16511L13.8819 2.74525V1.45464C13.8819 0.257629 12.5456 -0.424751 11.6101 0.293121L10.7266 0.970677Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.74528L1.4512 3.85827L3.15533 5.16514V0.970702L2.27178 0.293146C1.33465 -0.424781 0 0.257655 0 1.45461V2.74522V2.74528Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_21577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8834,
    height: 10.7029,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.edf0c5d63523d31ed24c218554afc7f6.svg";
export { ForwardRef as ReactComponent };